import React from 'react';
import { useHistory } from "react-router-dom";
import { FILEURL } from '../Config';

const SalesManagerCard = (props) => {
    const { salesManager, stats } = props;
    const history = useHistory();

    const getInitials = (firstName, lastName) => {
        const first = firstName ? firstName.charAt(0).toUpperCase() : '';
        const last = lastName ? lastName.charAt(0).toUpperCase() : '';
        return first + last || 'U';
    };

    return (
        <div className="profile-card-enhanced">
            <div className="profile-row">
                <div className="profile-info">
                    <div className="profile-avatar">
                        {salesManager?.profilePic ? (
                            <img
                                src={FILEURL + "/" + salesManager?.profilePic}
                                alt={salesManager?.firstName}
                            />
                        ) : (
                            getInitials(salesManager?.firstName, salesManager?.lastName)
                        )}
                    </div>
                    <div className="profile-details">
                        <div className="profile-name-row">
                            <h4>{salesManager?.firstName} {salesManager?.lastName}</h4>
                            <button
                                className="edit-icon-btn"
                                onClick={() => { history.push('/editSalesManager/' + salesManager?.uuid) }}
                            >
                                <i className="mdi mdi-pencil" />
                            </button>
                        </div>
                        <p>
                            {salesManager?.emailID}<br />
                            {salesManager?.phoneNo}
                        </p>
                    </div>
                </div>

                <div className="stats-container">
                    <div className="stat-card">
                        <div className="stat-icon">
                            <i className="mdi mdi-calendar-check" />
                        </div>
                        <div className="stat-content">
                            <h3>{stats?.eventsCount || 0}</h3>
                            <p>Events</p>
                        </div>
                    </div>
                    <div className="stat-card stat-card-clickable" onClick={() => history.push(`/schoolsData?createdBy=${salesManager?.uuid}`)}>
                        <div className="stat-icon">
                            <i className="mdi mdi-school" />
                        </div>
                        <div className="stat-content">
                            <h3>{stats?.schoolsCount || 0}</h3>
                            <p>Schools</p>
                        </div>
                    </div>
                    <div className="stat-card stat-card-clickable" onClick={() => history.push(`/distributors?createdBy=${salesManager?.uuid}`)}>
                        <div className="stat-icon">
                            <i className="mdi mdi-account-group" />
                        </div>
                        <div className="stat-content">
                            <h3>{stats?.distributorsCount || 0}</h3>
                            <p>Distributors</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SalesManagerCard;
